import styled from "styled-components";

import { Text } from "@similarweb/ui-components/foundations";

export const StyledConfirmModalDescription = styled(Text)`
    margin: 16px 24px 24px 24px;
`;
